import { isMobile } from 'react-device-detect';

// Import types
import type { ImageType, ProductImages } from 'types/api/images';
import type { Operators } from 'types/api/systems';

const getImageUrl = (images: ProductImages) => (type: ImageType) => images?.[type]?.[0]?.url;

export const getImages = (images: ProductImages, types: ImageType[]) => {
	if (!images) return [];

	return types.map(getImageUrl(images));
};

export const getImage = (images: ProductImages, type: ImageType | ImageType[]) => {
	if (typeof type === 'string') return getImageUrl(images)(type);
	return getImages(images, type).find((image) => image);
};

export const importIcon = (name: string) => {
	try {
		return require(`../assets/icons/${name}.svg`);
	} catch (e) {
		return '';
	}
};

export const getBannerImageSize = () => {
	const width = isMobile ? window.innerWidth : 1920;
	const height = isMobile ? Math.ceil(window.innerWidth / 4.8) : 400;
	return `w${width}-h${height}`;
};

export const getImageAddress = (uuid: string | null, type: ImageType) => `${process.env.REACT_APP_API_URL}/assets/${uuid}/${type}`;

export const getOperatorLogo = (operator: Operators) => `https://r.e.blueonline.tv/s/tvsmart/static/www/${operator}/logo_white_background.svg`;

type Options = {
	time?: string;
	width?: number;
	height?: number;
};

export const getCurrentSlide = (image: string | undefined, options: Options) => {
	try {
		if (!image) return '';
		const url = new URL(image);

		const { time, width, height } = options;

		url.searchParams.set('srcmode', '4');
		url.searchParams.set('type', '1');
		url.searchParams.set('quality', '80');

		if (time) {
			url.searchParams.set('time', time);
		}

		if (width) {
			url.searchParams.set('srcw', `${width}`);
			url.searchParams.set('dstw', `${width}`);
		}

		if (height) {
			url.searchParams.set('srch', `${height}`);
			url.searchParams.set('dsth', `${height}`);
		}

		return url.href;
	} catch (e) {
		return image;
	}
};
